module.exports = __webpack_public_path__ + "static/media/HeroHamburger.53e07b59.jpg";